module.exports = __webpack_public_path__ + "static/media/compliance.c8b8e29b.svg";